import { all } from 'async-saga';
import { actions } from '..';
import { selectMyMedia } from '../reducers/media';
import { takeEvery } from '../tools/async-saga-types';

const onRenderSelectionClosed = takeEvery(actions.renderSelectionClosed, async function (ctx, mediaItemId) {
  const all = selectMyMedia(ctx.getState())
  const media  = all.find(m => m.mediaItemId === mediaItemId)
  
  if (!media) {
    ctx.dispatch(actions.removeMediaItem(mediaItemId))
  }

})

export default all(
  onRenderSelectionClosed,
)
